export default {
  new_employee: 'Mitarbeiter hinzufügen',
  btn_cancel: 'Abbrechen',
  btn_add: 'Hinzufügen',
  first_name: 'Vorname',
  first_name_placeholder: 'Vornamen eingeben',
  last_name: 'Nachname',
  last_name_placeholder: 'Nachnamen eingeben',
  email: 'E-Mail',
  email_placeholder: 'E-Mail eingeben',
  internal_id: 'Internal ID',
  internal_id_placeholder: 'Internal ID eingeben',
  phone: 'Telefon',
  phone_placeholder: 'Telefon eingeben',
  workplace: 'Dienstort',
  workplace_placeholder: 'Dienstort eingeben',
  vacation_days: 'Urlaubsanspruch stunden',
  vacation_placeholder: 'Urlaubsanspruch eingeben',
  private_car: 'Privatauto',
  private_placeholder: 'Kennzeichen eingeben',
  company_car: 'Firmenwagen',
  company_placeholder: 'Kennzeichen eingeben',
  rental_car: 'Leihauto',
  role: 'Rolle',
  substitution: 'Vertretung (optional)',
  substitution_placeholder: 'Vertretung eingeben',
  substitution_manager: 'Vertretung',
  add_substitution: '+ zusätzliche Vertretung hinzufügen',
  add_private_car: '+ zusätzliches Privatauto',
  rate: 'KM-Satz',
  rate_placeholder: 'KM-Satz eingeben',
  area: 'Gebiet',
  area_placeholder: 'Gebiet eingeben',
  area_manager: 'Gebiet',
  add_area: '+ Gebiet hinzufügen',
  area_manager_text: 'Gebietsleitung',
  work_log: 'Tätigkeiten',
  work_calendar: 'Kalender',
  km_log: 'Kilometerstand',
  add_km: 'KM-Stand erfassen',
  add_reading: 'Monatlichen Kilometerstand erfassen',
  choose_month: 'Monat auswählen',
  mileage: 'Kilometerstand Monatsende',
  enter_mileage: 'Kilometerstand Monatsende eingeben',
  upload_photo: 'Foto vom Kilometerstand hochladen',
  error_format: 'Es sind nur JPG und PNG Dateien zulässig.',
  error_size: 'Die Dateigröße muss kleiner als 20 MB sein.',
  upload_drag: 'Datei hier herziehen oder',
  upload_click: 'zum Hochladen klicken',
  upload_tip: 'Nur 1 jpg/png-Datei mit einer Größe bis 20MB erlaubt',
  upload: 'Hochladen',
  km_end: 'KM-End',
  vacation: 'Abwesenheiten',
  type_employee: 'Rolle',
  phone_number: 'Telefon',
  password: 'Passwort',
  change: 'Ändern',
  info: {
    id: 'ID',
    area: 'Gebiet',
    rate: 'KM-Satz',
    email: 'E-Mail',
    supervisor: 'Vorgesetze/r',
    substitute: 'Vertretung',
    phone: 'Telefon',
    remaining: 'Urlaubsanspruch',
    requested: 'Urlaubsanfragen',
    admin: 'Geschäftsleitung',
    manager: 'HZ-Leitung',
    hours: 'Stunden',
  },
  is_deleted: 'ist gelöscht',
  deactivate_text:
    'Sind Sie sicher, dass sie folgende/n Admin Mitarbeiter/in deaktivieren wollen?',
  activate_text:
    'Sind Sie sicher, dass sie folgende/n Admin Mitarbeiter/in aktivieren wollen?',
  working_days: 'Arbeitstage',
  days_off: 'Abwesenheit',
  set_up_working_hours: 'Bitte individuelle Arbeitszeit eintragen',
  choose_working_day: 'Bitte legen Sie die Standardarbeitszeiten fest:',
  vacation_day: 'Urlaubsanspruch',
  sick_leave: 'Krankenstand',
  flextime: 'Gleitzeit',
  national_holiday: 'Feiertag',
  other: 'Sonstige',
  days: {
    monday: 'montag',
    tuesday: 'dienstag',
    wednesday: 'mittwoch',
    thursday: 'donnerstag',
    friday: 'freitag',
    saturday: 'samstag',
    sunday: 'sonntag',
  },
  rolling_days: {
    day_1: 'Tag 1',
    day_2: 'Tag 2',
    day_3: 'Tag 3',
    day_4: 'Tag 4',
  },
  months: {
    january: 'Januar',
    february: 'Februar',
    march: 'März',
    april: 'April',
    may: 'Mai',
    june: 'Juni',
    july: 'Juli',
    august: 'August',
    september: 'September',
    october: 'Oktober',
    november: 'November',
    december: 'Dezember',
  },
  has_electric_vehicle: 'Hat ein Elektrofahrzeug',
  kwh_log: 'Wallbox Zählerstand',
  month: 'Monat',
  kwh: 'kWh',
  km: 'km',
  delete_kwh_log_text: 'Sind Sie sich sicher, dass Sie den Wallbox Zählerstand aus dem System löschen wollen?',
  add_kwh: 'Zählerstand hinzufügen',
  add_kwh_reading: 'Monatlichen kWh-Zählerstand erfassen',
  kwh_value: 'Monatlicher kWh-Verbrauch',
  enter_kwh_value: 'Monatlicher kWh-Verbrauch eingeben',
  upload_kwh_photo: 'Foto vom Wallbox Zählerstand hochladen',
  profile: {
    settings: 'Einstellungen',
    kwh_price: 'Preis pro kWh',
    euro_per_kwh: '€/kWh',
    price_label: 'Preis, €/kWh',
    save: 'Speichern'
  }
}
